const comments = [
  {
    id: 'cmt-1',
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20profile%20avatar%20icon%2C%20warm%20orange%20gradient%20circle%2C%20minimalist%20design%2C%20soft%20lighting%2C%20clean%20background&width=80&height=80&seq=juzi-avatar-01&orientation=squarish',
    date: '2026-07-30',
    content: '用了桔子影院快一年了，最大的感受就是不卡！以前在其他平台看高清总是缓冲，桔子的播放体验真的流畅，画质也很清晰。推荐给身边好多朋友了。',
    rating: 5,
  },
  {
    id: 'cmt-2',
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20profile%20avatar%20icon%2C%20amber%20golden%20gradient%20circle%2C%20minimalist%20design%2C%20soft%20lighting%2C%20clean%20background&width=80&height=80&seq=juzi-avatar-02&orientation=squarish',
    date: '2026-07-29',
    content: '更新速度太给力了！繁花似锦每次更新我都是第一个看到的，比其他平台快好多。而且不用注册不用付费，真的良心。希望一直做下去。',
    rating: 5,
  },
  {
    id: 'cmt-3',
    name: '电影发烧友阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20profile%20avatar%20icon%2C%20warm%20coral%20gradient%20circle%2C%20minimalist%20design%2C%20soft%20lighting%2C%20clean%20background&width=80&height=80&seq=juzi-avatar-03&orientation=squarish',
    date: '2026-07-28',
    content: '作为一个重度电影爱好者，桔子的片库深度真的让我惊喜。很多冷门老片都能找到，而且画质修复得不错。专题策划也很有水平，发现了不少好片子。',
    rating: 4,
  },
  {
    id: 'cmt-4',
    name: '周末宅家党',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20profile%20avatar%20icon%2C%20warm%20peach%20gradient%20circle%2C%20minimalist%20design%2C%20soft%20lighting%2C%20clean%20background&width=80&height=80&seq=juzi-avatar-04&orientation=squarish',
    date: '2026-07-27',
    content: '手机上用也很方便，不用下载App，浏览器打开就能看。周末窝在沙发里刷了一整天剧，体验完全不比那些要开会员的平台差。强烈推荐！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">用户评价</h2>
          <p className="text-foreground-500 text-sm mt-2">来自真实用户的观影反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 border border-background-300/30 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < comment.rating ? 'ri-star-fill text-accent-400' : 'ri-star-fill text-background-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-400 text-xs leading-relaxed mb-4">{comment.content}</p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-300/20">
                <div className="w-8 h-8 rounded-full overflow-hidden bg-background-300 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-foreground-200 text-xs font-semibold">{comment.name}</p>
                  <p className="text-foreground-600 text-[10px]">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}